import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Native',
    description: 'The web + product agency for teams who value speed + quality above all else. One team covering strategy, design and development, with no handoffs in between.',
    url: 'https://www.native.agency',
    email: 'flaka.kallaba@azwedo.com',
    ogImage: 'https://www.native.agency/images/og/default.jpg',
    links: {
        twitter: 'https://x.com/thenativeagency',
        github: 'https://github.com/ship-studio'
    }
}

// Every case study image, video and large design asset lives in the site's storage, served from this CDN host.
export const CDN_BASE = 'https://native-agency-xtc.cdn.modulify.website'

export const cdn = (path: string): string => `${CDN_BASE}${path}`

export const primaryLinks = [
    { label: 'Work', href: '/work' },
    { label: 'Model', href: '/#model' },
    { label: 'Process', href: '/#process' }
]

export const mobileLinks = [
    { label: 'Work', href: '/work' },
    { label: 'Model', href: '/#model' },
    { label: 'Process', href: '/#process' },
    { label: 'About', href: '/about' },
    { label: 'Work with us', href: '/contact' }
]

export const socialLinks = [
    { label: 'X / Twitter', href: 'https://x.com/thenativeagency' },
    { label: 'GitHub', href: 'https://github.com/ship-studio' }
]

export const legalLinks = [
    { label: 'Terms of Service', href: '/terms' },
    { label: 'Privacy Policy', href: '/privacy' }
]

export const footerQuickLinks = [
    { label: 'Home', href: '/' },
    { label: 'Case Studies', href: '/work' },
    { label: 'About', href: '/about' },
    { label: 'Careers', href: '/careers' },
    { label: 'The Process', href: '/#process' },
    { label: 'Testimonials', href: '/#testimonials' },
    { label: 'Frequently Asked Questions', href: '/#faq' }
]
